import { useStoryblokLink } from "./useStoryblokLink";

export { useStoryblokLink };
